import gql from 'graphql-tag';

import client from '../graphqlAPI';

const USER_EDIT = gql`
  mutation Post(
    $id: String!,
    $email: String,
    $name: String,
    $lastname: String,
    $idNumber: String,
    $roles: [String],
    $addressName: String,
    $addressLastname: String,
    $addressStreet: String,
    $addressStreetNumber: String,
    $addressApartment: String,
    $addressCity: String,
    $addressProvince: String,
    $addressPostalCode: String,
    $addressCountry: String
  ) {
    userEdit(
      id: $id,
      email: $email,
      name: $name,
      lastname: $lastname,
      idNumber: $idNumber,
      roles: $roles,
      addressName: $addressName,
      addressLastname: $addressLastname,
      addressStreet: $addressStreet,
      addressStreetNumber: $addressStreetNumber,
      addressApartment: $addressApartment,
      addressCity: $addressCity,
      addressProvince: $addressProvince,
      addressPostalCode: $addressPostalCode,
      addressCountry: $addressCountry
    ) {
      isAuth
      isEdited
      error
    }
  }
`;

const userEdit = async ({
  id,
  email,
  name,
  lastname,
  idNumber,
  roles,
  addressName,
  addressLastname,
  addressStreet,
  addressStreetNumber,
  addressApartment,
  addressCity,
  addressProvince,
  addressPostalCode,
  addressCountry,
}) => {
  try {
    // Build variables object, only including defined values
    const variables = {
      id,
      email,
      name,
      roles,
    };

    // Add lastname and idNumber if defined
    if (lastname !== undefined) variables.lastname = lastname;
    if (idNumber !== undefined) variables.idNumber = idNumber;

    // Only add address fields that are defined (not undefined)
    if (addressName !== undefined) variables.addressName = addressName;
    if (addressLastname !== undefined) variables.addressLastname = addressLastname;
    if (addressStreet !== undefined) variables.addressStreet = addressStreet;
    if (addressStreetNumber !== undefined) variables.addressStreetNumber = addressStreetNumber;
    if (addressApartment !== undefined) variables.addressApartment = addressApartment;
    if (addressCity !== undefined) variables.addressCity = addressCity;
    if (addressProvince !== undefined) variables.addressProvince = addressProvince;
    if (addressPostalCode !== undefined) variables.addressPostalCode = addressPostalCode;
    if (addressCountry !== undefined) variables.addressCountry = addressCountry;

    console.log('userEdit mutation - variables being sent:', JSON.stringify(variables, null, 2));

    const result = await client.mutate({
      mutation: USER_EDIT,
      variables,
      fetchPolicy: 'no-cache',
    })
      .then(queryResult => queryResult)
      .catch((queryError) => {
        console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: Apollo Client Query Error: ${queryError}`);
        return null;
      });

    const { data: { userEdit: validatedFormData } } = result;

    if (validatedFormData) {
      return validatedFormData;
    }
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: GraphQL Query Error: validatedFormData = null`);
    return null;
  } catch (error) {
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: userEdit Error: ${error}`);
    return null;
  }
};

export default userEdit;